import { BehaviorSubject, Observable, Subject, first, map, takeUntil } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';

import { ConfigInitializerService, OccEndpointsService } from '@spartacus/core';

import { CaptchaTurnstileResponse } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CaptchaTurnstileService implements OnDestroy {
  protected readonly destroy$: Subject<void> = new Subject();

  private captchaTurnstileKey = new BehaviorSubject<string>(undefined);

  get captchaTurnstileKey$(): Observable<string> {
    return this.captchaTurnstileKey.asObservable().pipe(first((key) => key !== undefined));
  }

  constructor(
    private occEndpointsService: OccEndpointsService,
    private http: HttpClient,
    configInitializerService: ConfigInitializerService
  ) {
    configInitializerService
      .getStable('backend', 'context')
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.getCaptchaKey());
  }

  verifyCaptcha(token: string): Observable<boolean> {
    const url = this.occEndpointsService.buildUrl('verifyCaptcha');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post<CaptchaTurnstileResponse>(url, token, { headers })
      ?.pipe(map((result) => result.response.find((resElement) => resElement.key === 'success')?.value.value));
  }

  private getCaptchaKey(): void {
    const url = this.occEndpointsService.buildUrl('captchaKey');
    this.http
      .get<{ key: string }>(url)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => this.captchaTurnstileKey.next(response.key));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
